export const RoomMeasurementsPencilIcon = () => (
  <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden style={{ display: 'inline-flex', flexShrink: 0 }}>
    <path
      d='M0.76053 16.2801L1.14912 12.7178C1.16779 12.5466 1.24432 12.387 1.36604 12.2653L12.4328 1.19856C13.0231 0.608228 13.9802 0.608228 14.5705 1.19856L16.6754 3.30342C17.2657 3.89375 17.2657 4.85087 16.6754 5.4412L5.60868 16.5079C5.48696 16.6296 5.32733 16.7062 5.1562 16.7248L1.59385 17.1134C1.11359 17.1658 0.708141 16.7604 0.76053 16.2801Z'
      stroke='#4E9669'
      strokeWidth='1.51164'
    />
  </svg>
);
